import React, { useContext } from 'react';
import Icon from '../../../Icon/Icon';
import { TabsContext } from '../../Tabs.context';
import './HideContentIcon.css';
var defaultProps = {};
export default function HideContentIcon() {
  var _useContext = useContext(TabsContext),
    deselectable = _useContext.deselectable,
    hideActiveTab = _useContext.hideActiveTab;
  if (!deselectable) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Icon, {
    iconName: "xmark",
    onClick: hideActiveTab
  });
}
HideContentIcon.defaultProps = defaultProps;